module.exports = __webpack_public_path__ + "static/media/DSC_0178.20a8e403.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0178.jpg
// module id = 640
// module chunks = 0